var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-uploader"},[_c('input',{class:'image-edit-upload section-id-' + _vm.id,attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.handleUpload}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5777a8bc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUploader.vue
// module id = null
// module chunks = 